import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink, TabContent } from "reactstrap";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import TableHeader from "../../../../components/Common/TableView/TableHeader";
import { SyncVendor } from "../../../../components/CommonSvg";
import { exportDataExportRequest } from "../../../../redux/exportData/action";
import { syncVendorRequest } from "../../../../redux/admin/members/action";
import { commonConfirmBox } from "../../../../helper/messagehelpers";
import { RoleWiseModule } from "../../../../utils/generalUtils";
import {
  AdminAccess,
  SuperAdminAccess,
} from "../../../../constant/commonConstants";
import MemberList from "../MemberList";
import VendorList from "./VendorList";


function IndexZohoVender({ exportDataExportRequest, syncVendorRequest }) {
  /* the search sits here rather than in VendorList, so it has to be restored
     here too - see the listState note in VendorList.js */
  const restored = useLocation().state?.listState;
  const [search, setSearch] = useState(restored?.search || "");
  const [clear, setClear] = useState(false);
  const [cityId, setCityId] = useState("");
  const [stateId, setStateId] = useState("");
  const [assignedValue, setAssignedValue] = useState("");
  const [countyId, setCountyId] = useState("");
  const [filter, setFilter] = useState({
    value: "",
    label: "All",
  });
  const [modalView, setModaleView] = useState(false);
  const [tab, setTab] = useState("Vendor");
  const [emailSettingData, setEmailSettingData] = useState();
  const initialValues = {
    search: search,
    setSearch: setSearch,
    clear: clear,
    setClear: setClear,
    filter: filter?.value,
    cityId: cityId,
    assignedValue: assignedValue,
    setAssignedValue: setAssignedValue,
    countyId: countyId,
    setCountyId: setCountyId,
    setCityId: setCityId,
    stateId: stateId,
    setStateId: setStateId,
  };
  const handleModalToggle = () => {
    setModaleView(!modalView);
  };
  const [exportFilterData, setExportFilterData] = useState(false);

  const [filterView, setFilterView] = useState(false);
  useEffect(() => {
    if (filterView) {
      setFilterView(false);
    }
  }, [filterView]);

  useEffect(() => {
    if (tab) {
      setFilterView(true);
      setFilter({
        value: "",
        label: "All",
      });
      if (filterView) {
        setFilterView(false);
      }
    }
  }, [tab]);
  return (
    <div className="container">
      <TableHeader
        hedingName={"Vendor"}
        // linkUrl={"/admin/vendor/add"}
        buttonName={tab === "Vendor" ? "Add Vendor" : ""}
        searchBar={true}
        updateData={() => {}}
        setSearchData={setSearch}
        initialSearch={search}
        settings={
          RoleWiseModule(AdminAccess, SuperAdminAccess) && (
            <button
              className="creat_btn btn btn-secondary"
              onClick={async () => {
                const response = await commonConfirmBox(
                  "Are you sure you want to start Vendor sync?"
                );
                if (response) {
                  syncVendorRequest();
                }
              }}
            >
              <SyncVendor /> Sync Vendor
            </button>
          )
        }
      />
       <VendorList
              values={initialValues}
              
            />


    </div>
  );
}
const mapStateToProps = ({}) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    syncVendorRequest: () => dispatch(syncVendorRequest()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(IndexZohoVender);
